import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import 'pobble-components/dist/setup/sentry'

import React, { Fragment } from 'react'
import ReactDOM from 'react-dom'
import App from './components/app/app'

import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducer'
import { requestMiddleware } from 'pobble-components/dist/redux-helpers'

import 'normalize.css'
import { ConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'
import { ToastContainer } from 'pobble-components/dist/toast'
import { apiGetMe } from './common/api/profile'
import { PobbleStyles } from 'pobble-components/dist/styles'

const store = createStore(
  rootReducer,
  applyMiddleware(requestMiddleware, thunk)
)

const render = ({ me, meError }) => {
  ReactDOM.render(
    <Provider store={store}>
      <PobbleStyles>
        <Fragment>
          <App me={me} meError={meError} />
          <ConfirmationDialog />
          <ToastContainer />
        </Fragment>
      </PobbleStyles>
    </Provider>,
    document.getElementById('root')
  )
}

apiGetMe({
  include:
    'account.timestamps,account.email_identity.email,account.subscriptions,account.subscription_policy,account.names,account.policy,account.teacher_type.school.names,account.finish_signup_status,account.avatar'
}).then(res => render({ me: res }), e => render({ meError: e }))

// Lazy load external tools
setTimeout(() => import('pobble-components/dist/setup/external-tools'), 1000)
